import { createSelector } from 'selectors'
import { constants } from './conditionsBuilder.constant'

const getConditionBuilderComponents = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: constants.selector.conditionsBuilderComponent }, true)

export const getConditionBuilders = () => ({
	conditionBuilderComponents: getConditionBuilderComponents(),
})
